import { render, staticRenderFns } from "./modalManageProfileDefinitions.vue?vue&type=template&id=26c2bd7d&"
import script from "./modalManageProfileDefinitions.vue?vue&type=script&lang=js&"
export * from "./modalManageProfileDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports